// src/api/feedback.js
import axiosClient from './axiosClient';

/**
 * Submits user feedback for a specific article.
 *
 * @param {object} options
 * @param {string} options.article_id - The unique identifier (or URL) of the article.
 * @param {string} options.feedback - The feedback value, e.g. "relevant", "neutral", or "not_relevant".
 * @returns {Promise<object>} The API response data.
 */
export async function submitArticleFeedback({ article_id, feedback }) {
  const response = await axiosClient.post('/feedback/article', { article_id, feedback });
  return response.data;
}


/**
 * Submits user feedback for a specific message.
 *
 * @param {object} options
 * @param {string} options.chat_id - The unique identifier of the chat.
 * @param {string} options.message_id - The unique identifier of the message.
 * @param {string} options.feedback - The feedback value, e.g. "relevant", "neutral", or "not_relevant".
 * @returns {Promise<object>} The API response data.
 */
export async function submitMessageFeedback({ chat_id, message_id, feedback }) {
  const response = await axiosClient.post('/feedback/message', { chat_id, message_id, feedback });
  return response.data;
}